<template>
  <el-form class="zj-login-form" ref="form" :model="form" :label-width="labelWidth">
    <h1 class="zj-login-form-title">{{ title }}</h1>
      <el-form-item label="用户名">
        <el-input
          v-model="form.username"
          maxlength="20"
          placeholder="请输入用户名"
          @keyup.enter.native="onEnter"
          autofocus
          clearable></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model="form.password"
          maxlength="50"
          placeholder="请输入密码"
          @keyup.enter.native="onEnter"
          show-password
          clearable></el-input>
      </el-form-item>
      <el-form-item v-if="captchaEnabled" label="验证码">
        <div class="zj-login-form-captcha-row">
          <el-input
            class="zj-login-form-captcha-input"
            v-model="form.vcode"
            :maxlength="captchaLength"
            placeholder="请输入验证码"
            @keyup.enter.native="onEnter"
            clearable>
          </el-input>
          <el-button
            class="zj-login-form-captcha-img"
            type="text"
            @click="captchaTimestamp = (new Date()).getTime()">
            <el-image
              :src="captchaUrl"
              fit="none">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item class="zj-login-form-button-row" label-width="0px">
        <el-button type="primary" @click="onSubmit"
          :disabled="!submitEnabled">登 录</el-button>
        <el-button v-if="isCancelable" @click="onCancel">取 消</el-button>
      </el-form-item>
    </el-form>
</template>

<script>
import ZJApis from '../api'
import utils from '../utils';
export default {
  name: 'ZjLoginForm',
  data() {
      return {
        form: {
          username: '',
          password: '',
          vtoken: utils.uuid(),
          vcode: ''
        },
        labelWidth: '80px',
        captchaTimestamp: (new Date()).getTime(),
        is_login: false
      }
  },
  props: {
    title: String,
    cancelable: Boolean
  },
  computed: {
    // 是否启用验证码
    captchaEnabled() {
      return this.CNF('captcha.enabled', false) && this.captchaBaseUrl
    },
    // 验证码长度，默认 4 字符
    captchaLength() {
      return this.CNF('captcha.length', 4)
    },
    // 验证码的基 URL 地址
    captchaBaseUrl() {
      return this.CNF('captcha.base_url', '')
    },
    // 验证码的 URL 地址: captchaBaseUrl + 时间戳
    captchaUrl() {
      let url = this.captchaBaseUrl;
      url = url.replace('{$token}', this.form.vtoken).replace('{$timestamp}', this.captchaTimestamp);
      return url
    },
    // 是否允许提交: 输入框全部有值时，且不是正在登录，则允许提交
    submitEnabled() {
      return !this.is_login &&
        this.form.username &&
        this.form.password &&
        this.form.vtoken &&
        (!this.captchaEnabled ||
          (this.form.vcode &&
           this.form.vcode.length >= this.captchaLength))
    },
    // 是否显示取消按钮
    isCancelable() {
      return this.cancelable === true
    }
  },
  created() {
    this.form.username = this.user.LoginName || ''
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || '',
        type: 'error',
        customClass: 'zj-login-msgbox'
      })
    },
    // 登录
    login() {
      this.is_login = true
      let loginInfo = {
        LoginName: this.form.username,
        LoginPwd: this.form.password,
        vtoken: this.form.vtoken,
        vcode: this.form.vcode
      }
      new ZJApis.UserApi().GetUserByLoginInfo(loginInfo)
      .then(r => {
        r = r.data.Data;
        this.onLogin(r, loginInfo)
        this.is_login = false
      }).catch((e) => {
        console.log(e)
        this.errmsg(e.RspMsg ? e.RspMsg : '服务异常，请联系管理员！')
        this.is_login = false
      })
    },
    // 登录成功
    onLogin(user, loginInfo) {
      this.user.setUser(user, loginInfo.LoginPwd);
      this.$emit('login', user)
    },
    // 点击回车键
    onEnter() {
      if (this.submitEnabled) {
        this.onSubmit()
      }
    },
    // 点击登录按钮
    onSubmit() {
      this.login()
    },
    // 点击取消按钮
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
